// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadHeroCard-cls1_ZLX","cls2":"DownloadHeroCard-cls2_wi0 DownloadHeroCard-cls1_ZLX"};